<nav aria-label="vb-breadcrumb">
  <ol class="vb-breadcrumb">
    <li class="vb-breadcrumb_item" *ngFor="let item of menuItems" [ngClass]="{'active': item.active }">
      <a [attr.href]="item.url">{{ item.title }}</a>
    </li>
  </ol>
</nav>
